// @flow
import React from 'react';
import classnames from 'classnames';
import { isInteger } from 'lodash';

import { COLORS } from 'Components/utils/color/colors';

import { themes } from './ProgressBar.themes';

type Props = {
  className?: string,
  color?: Colors,
  max?: number,
  min?: number,
  theme?: string,
  value: number,
};

export function ProgressBar(props: Props) {
  const { className, color = COLORS.BLUE, min = 0, max = 10, theme = 'default', value } = props;

  if (!isInteger(value) || value < 0) return null;

  const stepPercent = 100 / max;
  const currentPercent = stepPercent * value;

  const { thBar, thRoot, thSize } = themes[theme];

  return (
    <div
      aria-valuemax={max}
      aria-valuemin={min}
      aria-valuenow={value}
      className={classnames(className, thRoot)}
      role="progressbar"
    >
      <div
        className={classnames(thBar, `bg-${color}`)}
        style={{ width: `${currentPercent}%`, height: thSize }}
        data-testid="progress-bar"
      />
    </div>
  );
}
